import {getCookie} from "./cookie";

export const checkGray = (cookie, flag = 'y') => {
  const result = getCookie(cookie) && getCookie(cookie).toLowerCase();
  return result === 'y';
};




// WEBPACK FOOTER //
// ./src/utils/checkGray.js